import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import CollectionSpotlight from "@/pages/home/components/CollectionSpotlight";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { movieItems, sortItems, tvItems } from "@/utils/catalog";

export default function Home() {
  const latestMovies = sortItems(movieItems, "newest").slice(0, 10);
  const hotSeries = sortItems(tvItems, "popular").slice(0, 10);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroCarousel />

        <CategoryShortcuts />

        <section className="w-full px-4 pb-4 md:px-8 md:pb-6">
          <SectionHeading
            eyebrow="即将热映"
            title="最新上映电影"
            description="汇集近期上映与即将上线的电影作品，含类型、年份与评分预览。"
            moreTo="/movies"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {latestMovies.map((item) => (
              <MovieCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <section className="w-full px-4 py-12 md:px-8 md:py-16">
          <SectionHeading
            eyebrow="热播榜单"
            title="热门电视剧"
            description="根据人气与评分综合排序的剧集推荐，追更不迷路。"
            moreTo="/tvseries"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {hotSeries.map((item) => (
              <MovieCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <CollectionSpotlight />

        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}